import React from 'react';
import { Location } from 'history';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import MFAForm from './Forms/MFAForm';

export const DefaultMFA = (props: { location: Location }) => (
  <LoginBase type="default" header={<Header />}>
    <MFAForm location={props.location} />
  </LoginBase>
);
